import Model from "../classes/Model";
import Api from "../classes/api/ClientSubscription";
import Subscription from "./Subscription";
import Client from "./Client";

export default class ClientSubscription extends Model {

    get id() {
        return this._id;
    }

    set clientId(value) {
        this._clientId = value;
    }
    get clientId() {
        return this._clientId;
    }

    set subscriptionId(value) {
        this._subscriptionId = value;
    }
    get subscriptionId() {
        return this._subscriptionId;
    }

    set count(value) {
        this._count = value;
    }
    get count() {
        return this._count;
    }

    set dateActivate(value) {
        this._dateActivate = value;
    }
    get dateActivate() {
        return this._dateActivate;
    }

    set dateExpire(value) {
        this._dateExpire = value;
    }
    get dateExpire() {
        return this._dateExpire;
    }

    set dateVisitLast(value) {
        this._dateVisitLast = value;
    }
    get dateVisitLast() {
        return this._dateVisitLast;
    }

    set status(value) {
        this._status = value;
    }
    get status() {
        return this._status;
    }

    set hide(value) {
        this._hide = value;
    }
    get hide() {
        return this._hide;
    }

    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }

    get client() {
        return this._client;
    }
    set client(value) {
        this._client = value;
    }

    get subscription() {
        return this._subscription;
    }
    set subscription(value) {
        this._subscription = value;
    }

    static get STATUS_ACTIVE() { return 1; }
    static get STATUS_DISABLED() { return 0; }

    constructor (config) {
        super();

        for (let field in config) {
            if (config.hasOwnProperty(field) === false) {
                continue;
            }
            this[`_${field}`] = config[field];
        }
    }

    toRequest() {
        return {
            // id: this.id,
            // name: this.name,
            // price: this.price,
            // comment: this.comment,
        };
    }

    static toResponse(data) {
        let subscription = undefined;
        if (undefined !== data.subscription && data.subscription) {
            subscription = new Subscription(Subscription.toResponse(data.subscription));
        }
        let client = undefined;
        if (undefined !== data.client && data.client) {
            client = new Client(Client.toResponse(data.client));
        }
        return {
            id: data.id,
            clientId: data.client_id,
            subscriptionId: data.subscription_id,
            count: data.count,
            dateActivate: data.date_activate,
            days: data.days,
            dateExpire: data.date_expire,
            dateVisitLast: data.date_visit_last,
            status: data.status,
            hide: data.hide,
            createdAt: data.created_at,
            createdBy: data.created_by,
            subscription: subscription,
            client: client,
        };
    }

    static getListByClient(clientId) {
        return Api.getListByClient(clientId).then((response) => {
            let data = [];
            for (let subscription of response.data) {
                data.push(new this(this.toResponse(subscription)));
            }
            return {data, headers: response.headers};
        });
    }

    static getList(page = 1, perPage = 10, sort = undefined, extraFields = undefined) {
        return Api.getList(page, perPage, sort, extraFields).then((response) => {
            let data = [];
            for (let subscription of response.data) {
                data.push(new this(this.toResponse(subscription)));
            }
            return {data, headers: response.headers};
        });
    }

    activate() {
        return Api.activate(this.id).then((response) => {
            return response.data;
        });
    }

    activateById(subscriptionId) {
        return Api.activate(subscriptionId).then((response) => {
            return response.data;
        });
    }

    static activateByIdStatic(subscriptionId) {
        return Api.activate(subscriptionId).then((response) => {
            return response.data;
        });
    }

    addCount(count, sum, paymentType) {
        return Api.addCount(this.id, count, sum, paymentType).then((response) => {
            return response.data.result;
        });
    }

    addDays(days, sum, paymentType) {
        return Api.addDays(this.id, days, sum, paymentType).then((response) => {
            return response.data.result;
        });
    }

    setHide() {
        return Api.hide(this.id).then((response) => {
            return response.data.result;
        });
    }

    remove() {
        return Api.remove(this.id).then((response) => {
            return response.data.result;
        });
    }

}
